export enum PhotoType {
    OneTime = 'onetime',
    Permanent = 'permanent'
}